import React from "react";
import HUDenv from "../components/HUDenv";
import HUDMetrics from "../components/HUDMetrics";
import HUDproduct from "../components/HUDproduct.js";
import HUDpricing from '../components/HUDpricing.js';
import HUDpromotion from '../components/HUDpromotion.js';
import PolicyLever from "../components/PolicyLever";
import Graphs from "../components/Graphs";
import "../../node_modules/react-grid-layout/css/styles.css";
import "../../node_modules/react-resizable/css/styles.css";
import classNames from 'classnames';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Fab from '@material-ui/core/Fab';
import CheckIcon from '@material-ui/icons/PlayArrow';
import SaveIcon from '@material-ui/icons/StopRounded';
import CircularProgress from '@material-ui/core/CircularProgress';
import AssignmentIcon from '@material-ui/icons/AssignmentTurnedInRounded';
import GlobalEvents from '../utils/global-events';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import CountryView from './CountryView.js';
import ReactTooltip from "react-tooltip";
import "../css/ReactGrid.css";
import '../css/App.css';
import { ResizableBox } from 'react-resizable';
import IconButton from '@material-ui/core/IconButton';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import WarningDialogue from '../components/WarningDialogue'
import "../../node_modules/react-resizable/css/styles.css";
import config from "../utils/config";

const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
    buttonSuccess: {
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: "absolute",
        top: "10px",
        left: "47.5%",
    },
    fabProgress: {
        color: green[500],
        position: 'absolute',
        top: -6,
        left: -6,
        zIndex: 1,
    },
});

class ReactGrid extends React.PureComponent {

    state = {
        openWarning: false,
        hide: false,
        width: "100vw",
        height: "77.5vh",
        graphResetKey: 0,
        rWidth: document.documentElement.clientWidth * .3,
        rHeight: document.documentElement.clientHeight * .795,
        totalAgents: 0,
        currentTick: 0,
        totalTick: 0,
        tickPercent: 0,
        countryWidth: window.innerWidth < 1900 ? 785.6 : 815.6,
    }


    componentDidMount() {

        if (sessionStorage.getItem('namespace') === "openScenario") {
            sessionStorage.setItem('currentTick', 1)
        }
        else {
            sessionStorage.setItem('currentTick', 0)
        }


        window.addEventListener('resize', this.calculateCountryWidth);
        this.props.subscribe_ns("simulation_status", this.tickProgressing);
        sessionStorage.setItem("zoom", this.props.zoom);
        GlobalEvents.on("showendinfo", () => {
            this.setState({
                simCompleteStatus: true
            })
        });
    }

    componentWillMount() {
        window.removeEventListener('resize', this.calculateCountryWidth);
    }

    componentWillUnmount() {
        this.props.unsubscribe_ns("simulation_status", data => {
        });
    }

    triggersimu = () => {
        GlobalEvents.trigger('startsim');
    }

    tickProgressing = (tickOb) => {
        const self = this;
        sessionStorage.setItem('currentTick', tickOb.tickNum + 1)
        sessionStorage.setItem('TotalAgentsS', tickOb.totalAgents)
        self.setState({
            currentTick: tickOb.tickNum + 1,
            totalTick: tickOb.totalTicks,
            totalAgents: tickOb.totalAgents,
            tickPercent: ((tickOb.tickNum + 1) / tickOb.totalTicks) * 100,
        });
    }

    changeTab = (e, v) => {
        this.setState({ tab: v });
    }

    onArrowClick() {

        const self = this;

        if (!self.state.hide) {
            self.setState({
                hide: !self.state.hide,
            })
        }
        else {
            self.setState({
                hide: !self.state.hide,
            })
        }

        setTimeout(() => {
            this.onResizeStop();
        }, 2000)
    }

    onResizeStop() {

        this.calculateCountryWidth();

        const myDiv = document.getElementById("graphsGrid");
        let divRatio = (myDiv.clientWidth / document.documentElement.clientWidth) * 100;
        let zoom = 0;
        // let long = 0;

        if (divRatio >= 45 && !this.state.hide) {
            sessionStorage.setItem("zoom", 2.7)
            // sessionStorage.setItem("long", -21)
        }
        else {

            if (divRatio >= 65) {
                divRatio = 65
            }

            if (this.state.hide) {
                zoom = 3.8 - ((divRatio - 30) * 0.025);
                // long = -83 + ((divRatio - 30));
            }
            else {
                zoom = 3.3 - ((divRatio - 30) * 0.04);
                // long = -56 + ((zoom / 1.65) * (divRatio - 30));
            }
            sessionStorage.setItem("zoom", zoom)
        }
    }

    componentDidUpdate() {
        this.calculateCountryWidth();
    }

    calculateCountryWidth = () => {
        let countWid = 0;
        const graGrid = document.getElementById("graphsGrid");
        const policyLeverGrid = document.getElementById("policyLeverGrid");
        if (policyLeverGrid) {
            countWid = graGrid.getBoundingClientRect().left - policyLeverGrid.getBoundingClientRect().right;
        }

        if (!this.state.hide) {
            this.setState({ countryWidth: countWid - 10 })
        }
        else {
            this.setState({ countryWidth: countWid - 70 })
        }

    }

    callLanding() {

        this.setState({
            openWarning: true
        })

    }

    goToHome() {

        this.setState({
            openWarning: false
        })
        GlobalEvents.trigger("gotohome");

        GlobalEvents.trigger("triggercountry", 'usa');
        this.props.disconnectSocket();
        let tempID = sessionStorage.getItem('userId')
        let temptab = sessionStorage.getItem('tab')
        sessionStorage.clear()
        sessionStorage.setItem('userId', tempID)
        sessionStorage.setItem('tab', temptab)

    }

    handleCloseWarning() {
        this.setState({
            openWarning: false
        })
    }

    render() {

        const self = this;
        const { classes } = this.props;
        const buttonClassname = classNames({
            [classes.buttonSuccess]: !self.props.simStarted,
        });
        let agents = 0;
        let duration = 0;

        let scenarioName = "";

        if (this.props.namespace === "openScenario") {
            const scenarioDetail = JSON.parse(sessionStorage.getItem("scenarioDetail"));
            scenarioName = scenarioDetail[0].name;
        } else {
            scenarioName = config.scenarioName;
            const simSettings = JSON.parse(sessionStorage.getItem('simSettings'));
            agents = simSettings.accordians[0].content[0].selectedValue;
            duration = simSettings.accordians[0].content[1].selectedValue / 24;
        }

        return (
            <>

                <div className="backContainer">
                    <div style={{ marginLeft: '20px' }}>
                        <IconButton onClick={this.callLanding.bind(this)} color="white" >
                            <HomeOutlinedIcon style={{ color: '#abb4b8', fontSize: "calc(1vh + 1vw)" }} />
                        </IconButton>
                        <WarningDialogue
                            handleCloseWarning={this.handleCloseWarning.bind(this)}
                            open={this.state.openWarning}
                            handleAction2={this.goToHome.bind(this)}
                            title="Go to home"
                            body="Are you sure you want to leave the page?"
                            action1='Stay on page'
                            action2="Go home" />
                    </div>
                    <ChevronRightIcon className="sceneIcon" style={{ fontSize: 'calc(1vh + 1vw)' }} />
                    <div>
                        <div className="sceneLabel">Scenario Name</div>
                        <div
                            data-tip
                            data-for='scenarioName'
                            className="scenarioName">{scenarioName}
                        </div>
                    </div>
                    <ReactTooltip
                        class='scenarioHover'
                        id='scenarioName'
                        getContent={dataTip => (
                            <div style={{ textAlign: "center" }}>
                                <div
                                    style={{
                                        width: 150,
                                        wordWrap: "break-word",
                                        marginBottom: "2px"
                                    }}
                                >
                                    <span>
                                        {scenarioName}
                                    </span>
                                </div>
                            </div>
                        )}
                        effect='solid'
                        place={"right"}
                        border={false}
                        type={"light"}
                    />


                </div>
                <div className="hud-container">
                    <HUDMetrics subscribe_ns={this.props.subscribe_ns} />
                    <HUDenv border="2px solid lightgrey" key="drink2" subscribe_ns={this.props.subscribe_ns} />
                    <HUDproduct key="sleep" subscribe_ns={this.props.subscribe_ns} />
                    <HUDpricing key="sleep2" subscribe_ns={this.props.subscribe_ns} />
                    <HUDpromotion key='promotion' subscribe_ns={this.props.subscribe_ns} />
                </div>
                <div className="loaderWrapper" style={this.props.namespace === "openScenario" ? { "display": "none" } : null}>
                    <div className={classes.wrapper}>
                        <Fab title={!self.props.simStarted ? "Start Simulation" : ""} color="primary" size={'3vw'}
                            className={buttonClassname} id="startsimul" onClick={self.triggersimu}
                            style={{ zIndex: 11, width: '3vw', height: '3vw', minHeight: '3vw' }}>
                            {!self.props.simStarted ?
                                <CheckIcon fontSize={"2vw !important"} /> :
                                sessionStorage.getItem('simCompleted') === 'true' ?
                                    <AssignmentIcon fontSize={"2vw"} /> : <SaveIcon fontSize={"2vw"} />}
                        </Fab>
                        {sessionStorage.getItem('simStarted') === 'true' &&
                            <div>
                                <div className="statusBar">
                                    Total number of agents: {self.state.totalAgents ? self.state.totalAgents : agents}
                                </div>
                                <div className="statusBar_2">
                                    <div className="statusbar_2_txt" style={{
                                        display: "inline-block", position: "absolute",
                                        right: "1.65vw"
                                    }}>
                                        Day {Math.ceil(self.state.currentTick / 24) || 0} of {Math.ceil(self.state.totalTick / 24) || duration}<br />
                                        {
                                            sessionStorage.getItem('simCompleted') === 'true' ?
                                                <text>24:00  Hours</text>
                                                :
                                                <text>{(Math.floor(((self.state.currentTick) % 24) / 10) ? ((self.state.currentTick - 1) % 24) : ("0" + ((self.state.currentTick % 24) || "0")))}:00  Hours</text>
                                        }
                                    </div>
                                    <div style={{
                                        display: "inline-block",
                                        right: "3%",
                                        position: "absolute",
                                        bottom: "11%"
                                    }}>
                                        {(6 <= ((self.state.currentTick - 1) % 24)) && (((self.state.currentTick - 1) % 24) <= 18) ?
                                            <img alt={"day"} className={"dayNight"} src={"day_timer_icon.svg"} /> :
                                            <img alt={"night"} className={"dayNight"} src={"moon_timer_icon.svg"} />}
                                    </div>
                                </div>

                            </div>}
                        {
                            self.props.simStarted
                            &&
                            <CircularProgress
                                key={self.state.tickPercent}
                                variant={(self.props.simStarted && self.state.tickPercent === 0 ? "indeterminate" : "static")}
                                value={self.state.tickPercent}
                                size={'3.5vw'}
                                style={{ zIndex: 10, top: '-0.5vh', left: '-0.2vw' }}
                                className={classes.fabProgress} />
                        }
                    </div>
                </div>
                <div className="gridComponents">
                    <div className={!this.state.hide && this.props.namespace === "simulation" ? "policyLeverGrid" : "policyLeverGridHidden"} id="policyLeverGrid">
                        {this.props.namespace === "simulation" ?
                            <>
                                <div className={!this.state.hide ? "minimize" : "minimizeHidden"} style={this.props.namespace !== "simulation" ? { "display": "none" } : null} onClick={this.onArrowClick.bind(this)} >
                                    {this.state.hide ?
                                        (
                                            <>
                                                <img
                                                    className="arrowHidden"
                                                    src="openArrow2.svg"
                                                    alt="Collapse"
                                                    title="Open Policy Lever"
                                                />
                                                <div className="collapsedText">Policy Levers</div>
                                                <img
                                                    className="arrowHidden1"
                                                    src="openArrow1.svg"
                                                    alt="Collapse"
                                                    title="Open Policy Lever"
                                                />
                                            </>
                                        )
                                        :
                                        (
                                            <>
                                                <img
                                                    className="arrow"
                                                    src="openArrow2.svg"
                                                    alt="Collapse"
                                                    title="Open Policy Lever"
                                                />
                                                <div className="collapsedText1">Policy Levers</div>
                                                <img
                                                    className="arrow1"
                                                    src="closeArrow.svg"
                                                    alt="Collapse"
                                                    title="Open Policy Lever"
                                                />
                                            </>
                                        )
                                    }

                                </div>
                                <PolicyLever showNotification={self.props.showNotification} />
                            </>
                            : null}
                    </div>
                    <div id="Map" className={!self.state.hide && this.props.namespace === "simulation" ? "countryViewGrid" : "countryViewGridHidden"}>
                        <CountryView
                            hide={self.state.hide}
                            emit_data={self.props.emit_data}
                            showNotification={self.props.showNotification}
                            countryname={self.props.countryname}
                            subscribe_ns={self.props.subscribe_ns}
                            unsubscribe_ns={self.props.unsubscribe_ns}
                            width={self.state.width}
                            height={self.state.height}
                            latitude={self.props.latitude}
                            longitude={self.props.longitude}
                            zoom={self.props.zoom}
                            pitch={self.props.pitch}
                            minPitch={self.props.minPitch}
                            maxPitch={self.props.maxPitch}
                            center={self.props.center}
                            geourl={self.props.geourl}
                            mapStyle={self.props.mapStyle}
                            ns_value='simulation_data'
                            ns_value2="msa_data"
                            simStarted={self.props.simStarted}
                            countryWidth={self.state.countryWidth}
                            namespace={this.props.namespace}
                        />
                    </div>
                    <div className="graphsGrid" id="graphsGrid">
                        <ResizableBox
                            key={self.state.graphResetKey}
                            axis="x"
                            width={this.state.rWidth}
                            height={this.state.rHeight}
                            minConstraints={[document.documentElement.clientWidth * .3, document.documentElement.clientHeight * .795]}
                            maxConstraints={[document.documentElement.clientWidth * .73, document.documentElement.clientHeight * .795]}
                            onResizeStop={this.onResizeStop.bind(this)}
                            resizeHandles={['w']}>
                            <Graphs
                                showNotification={self.props.showNotification}
                                subscribe_ns={self.props.subscribe_ns}
                                unsubscribe_ns={self.props.unsubscribe_ns}
                                countryWidth={self.state.countryWidth}
                            />
                        </ResizableBox>
                    </div>
                </div>
            </>
        );
    }
}

export default withStyles(styles)(ReactGrid);
